import React from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import WearableBodySummaryQuery from './WearableBodySummaryQuery';

export interface WearableBodySummary {
  provider: string;
  device: string | null;
  weightKg: number | null;
  heightCm: number | null;
  bodyFatPercent: number | null;
  muscleMassKg: number | null;
  bmi: number | null;
  age: number | null;
  restingHeartRateBpm: number | null;
  avgHrvSdnnMs: number | null;
  avgPeriodDays: number | null;
  bodyTemperatureCelsius: number | null;
  skinTemperatureCelsius: number | null;
}

export interface WearableBodySummaryResult {
  loading: boolean;
  bodySummary: WearableBodySummary | null;
  error: ApolloError | undefined;
  refetch: () => Promise<unknown>;
}

interface Props {
  children: (result: WearableBodySummaryResult) => React.ReactElement;
}

const WearableBodySummaryConnectorApollo: React.FC<Props> = ({ children }) => {
  const { loading, data, error, refetch } = useQuery(WearableBodySummaryQuery, {
    fetchPolicy: 'cache-and-network',
  });

  return children({
    loading,
    bodySummary: data?.wearable?.bodySummary ?? null,
    error,
    refetch,
  });
};

export default WearableBodySummaryConnectorApollo;
